module.exports = __webpack_public_path__ + "img/how-to-use-gbwhatsapp-without-banned-x1.2d6fa62e.webp";